import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const OrderDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Order Detail</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default OrderDetailHeader;
